const initialState = {
  dashboardConfig: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_DASHBOARD_CONFIG":
      return {
        ...state,
        dashboardConfig: action.payload,
      };

    default:
      return state;
  }
};

export default dashboardReducer;